<template>
  <span :class="badgeClasses">
    <span v-if="$slots['left-icon']" class="badge-icon badge-icon-left">
      <slot name="left-icon"></slot>
    </span>

    <div v-if="$slots.default" class="badge-content">
      <slot></slot>
    </div>

    <span v-if="$slots['right-icon']" class="badge-icon badge-icon-right">
      <slot name="right-icon"></slot>
    </span>
  </span>
</template>

<script>
export default {
  name: 'UiBadge',
  props: {
    variant: {
      type: String,
      default: 'primary',
      validator: value =>
        ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark', 'promo'].includes(value)
    },
    pill: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'md',
      validator: value => ['sm', 'md', 'lg'].includes(value)
    },
    position: {
      type: String,
      default: '',
      validator: value => ['top-right', 'top-left', 'bottom-right', 'bottom-left', ''].includes(value)
    },
    textTransform: {
      type: String,
      validator: value => ['lowercase', 'uppercase'].includes(value)
    }
  },
  computed: {
    badgeClasses() {
      return [
        'badge',
        `badge-${this.variant}`,
        { 'badge-pill': this.pill },
        'ui-badge',
        `ui-badge-${this.size}`,
        this.position ? `position-${this.position}` : '',
        this.textTransform ? `text-${this.textTransform}` : '',
      ];
    }
  }
};
</script>

<style>
/* Custom styles using the ui-badge class to override Bootstrap defaults */
.ui-badge {
  display: inline-flex;
  gap: 4px;
  align-items: center;
  justify-content: center;

}

.ui-badge .badge-content {
  display: inline-flex;
  align-items: center;
}

.ui-badge .badge-icon {
  display: inline-flex;
  align-items: center;
}

.ui-badge.badge-success {
  background-color: var(--color-badge-success) !important;
}

.ui-badge.badge-promo {
  background-color: var(--color-badge-success-dark) !important;
}

.ui-badge.badge-primary {
  background-color: var(--color-primary) !important;
}
.ui-badge.badge-secondary {
  background-color: var(--color-secondary) !important;
}

.ui-badge.badge-pill {
  border-radius: 10rem;
}

.ui-badge.ui-badge-sm {
  font-size: 9px;
  font-weight: 600;
  line-height: 16px;
  gap: 2px;
}

.ui-badge.ui-badge-lg {
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  gap: 2px;
}

.ui-badge.position-top-right {
  position: absolute;
  right: -1px;
  top: -5px;
  z-index: 999;
}
.ui-badge.position-top-left {
  position: absolute;
  left: 0px;
  top: -5px;
  z-index: 999;
}
</style>
